export default __webpack_public_path__ + "static/media/create-quote.80b63510.png";